import { RefreshCw } from "lucide-react";
import { useTranslation } from "react-i18next";
import { AanmeldShell } from "@/components/AanmeldShell";
import { Button } from "@/components/ui/button";
import { SkeletonLine } from "@/components/ui/skeleton";
import { Wedstrijddagkaart } from "@/features/planning/Wedstrijddagkaart";
import { eigenAandeel, eigenKorpsIds } from "@/features/planning/eigenKorpsen";
import { usePlanning } from "@/features/planning/usePlanning";
import { useSeizoenen } from "@/features/session/useSeizoenen";

/**
 * Everyone sees the whole season, as the boekje always showed it: a speelschema with only your own
 * ploeg is a reminder, not a schedule. The only screen showing another korps's entries, so the API
 * crosses a default-deny filter. A niveau that is still concept reaches beheerders only.
 */
export function PlanningPage() {
  const { t } = useTranslation(["planning"]);
  const { data: seizoenen } = useSeizoenen();
  const seizoen = seizoenen?.[0];
  const {
    data: planning,
    isPending,
    isFetching,
    refetch,
  } = usePlanning(seizoen?.id);

  return (
    <AanmeldShell
      titel={t("planning:title")}
      uitleg={
        !seizoen ? (
          <SkeletonLine className="w-72" />
        ) : isPending ? (
          <SkeletonLine className="w-72" />
        ) : planning ? (
          t("planning:uitleg", { naam: planning.seizoenNaam })
        ) : (
          t("planning:geenPlanning")
        )
      }
    >
      {(me) => {
        if (!planning) return null;

        const eigen = eigenKorpsIds(me);

        return (
          <div className="space-y-6">
            <div className="flex flex-wrap items-center justify-end gap-3 text-sm">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => void refetch()}
                disabled={isFetching}
              >
                <RefreshCw aria-hidden />
                {t("planning:vernieuwen")}
              </Button>
            </div>

            {/* A list, not a grid of divs: a screen reader then says how many dagen there are and
              where in them you are. */}
            <ul className="grid gap-4 md:grid-cols-2">
              {planning.dagen.map((dag) => (
                <li key={dag.id}>
                  <Wedstrijddagkaart
                    dag={dag}
                    aandeel={eigenAandeel(dag, eigen)}
                  />
                </li>
              ))}
            </ul>
          </div>
        );
      }}
    </AanmeldShell>
  );
}
